import {createSelector, createSlice} from '@reduxjs/toolkit';

import authList from "../../routes/authList";
import {selectSelectedPharmacist, selectTooManyEmployees, selectUserType} from "../auth/authSlice";
import {selectSelectedPharmacy} from "../pharmacySlice";


export interface RouteState {
    routesAuth: string[]
}

const initialState: RouteState = {
    routesAuth: authList.list.map(ele => ele.name),
};


export const routeSlice = createSlice({
    name: 'route',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {

    },
});

// export const {
//
// } = routeSlice.actions;






export const selectFilterAuthRoute =  createSelector( selectUserType, selectSelectedPharmacist, selectSelectedPharmacy, selectTooManyEmployees, (typeUser, pharmacist, pharmacy, tooManyEmployees) => {
    const getPermissions = (permissions: string[]) => {
        const obj:any = {
            selectedPharmacist: () => !!pharmacist,
            selectedPharmacy: () => !!pharmacy,
            limitEmployeeRespected: () => !tooManyEmployees
        }
        return permissions.reduce((control, ele) => obj[ele]? (obj[ele]()? control : false) : control, true)
    }
    console.log(pharmacy)
    console.log(authList.list)
    !!authList && typeUser && authList.list.filter(r =>  {
        if(r.path === '/hoursMany'){
            debugger;
        }
     return (!r.roles || r.roles.includes(typeUser)) && (r.permissions && r.permissions.length ? getPermissions(r.permissions) : true)
    })
    return !!authList  && typeUser? ({
        ...authList,
        list: authList.list.filter(r =>  (!r.roles || r.roles.includes(typeUser)) && (r.permissions && r.permissions.length ? getPermissions(r.permissions) : true))
    }): undefined
});




export default routeSlice.reducer;
